export const AUTOMATED_REPORTS = 'Automated Reports'
